// Clave de Google Maps (Geocoding). Se lee de la variable de entorno REACT_APP_
// (baked en el build). No hardcodear la clave aquí: este archivo está en git.
// Recuerda restringirla por referrer HTTP en Google Cloud Console.
export const config = {
  mapAPI: process.env.REACT_APP_GOOGLE_API_KEY
}
